// @ts-nocheck
/* eslint-disable complexity */
import { ReactElement } from "react";

import { ViewModelError } from "@atlassiansox/bxp-content-framework";

import { ViewModel } from "./view-models";
import {
    Page,
    UiAccordion,
    UiAddToSlackSection,
    UiAnimatedHeroSection,
    UiBlock,
    UiButton,
    UiCallout,
    UiCaption,
    UiCard,
    UiCarousel,
    UiColumn,
    UiContactForm,
    UiDownloadButton,
    UiEmailSignup,
    UiFeatureSection,
    UiFooterNav,
    UiFooterNavBasic,
    UiGuide,
    UiHeaderNav,
    UiHeading,
    UiIcon,
    UiImage,
    UiImageSet,
    UiIntegration,
    UiIntegrationSection,
    UiLink,
    UiLinkBlock,
    UiListCarousel,
    UiLoginContainer,
    UiLoginSignupForm,
    UiMarkdown,
    UiMarketoForm,
    UiModal,
    UiNavBanner,
    UiNavBlogArticle,
    UiNavImages,
    UiNavLink,
    UiPowerUp,
    UiPricingCalculator,
    UiPricingComparisonTable,
    UiPricingGrid,
    UiQuote,
    UiRecommendShare,
    UiRotatingImages,
    UiRotatingItems,
    UiSection,
    UiSectionGroup,
    UiSocialLoginSignupButton,
    UiSocialProof,
    UiSocialShare,
    UiSpacer,
    UiSplitSection,
    UiStack,
    UiStatuspage,
    UiStoryline,
    UiTab,
    UiTabPanel,
    UiTemplateGallery,
    UiTextBlock,
    UiTooltip,
    UiTrelloBoard,
    UiValueProp,
    UiVariationContainer,
    UiVideo,
    UiVideoPlayer,
    UiWebinarLink,
    UiWorkspacePicker
} from "./views";

/**
 * TODO: view models should be rendered automatically by the framework
 */

/**
 * TODO: add Sentry error boundary with tags
 * scope.setTags({team: 'bxpt', modelType: viewModel.type, contentId: viewModel.id})
 */

export function renderViewModel(viewModel: ViewModel): ReactElement {
    switch (viewModel.type) {
        case "page":
            return <Page key={viewModel.id} model={viewModel} />;
        case "uiAccordion":
            return <UiAccordion key={viewModel.id} model={viewModel} />;
        case "uiAddToSlackSection":
            return <UiAddToSlackSection key={viewModel.id} model={viewModel} />;
        case "uiAnimatedHeroSection":
            return (
                <UiAnimatedHeroSection key={viewModel.id} model={viewModel} />
            );
        case "uiBlock":
            return <UiBlock key={viewModel.id} model={viewModel} />;
        case "uiButton":
            return <UiButton key={viewModel.id} model={viewModel} />;
        case "uiCallout":
            return <UiCallout key={viewModel.id} model={viewModel} />;
        case "uiCaption":
            return <UiCaption key={viewModel.id} model={viewModel} />;
        case "uiCard":
            return <UiCard key={viewModel.id} model={viewModel} />;
        case "uiCarousel":
            return <UiCarousel key={viewModel.id} model={viewModel} />;
        case "uiColumn":
            return <UiColumn key={viewModel.id} model={viewModel} />;
        case "uiContactForm":
            return <UiContactForm key={viewModel.id} model={viewModel} />;
        case "uiDownloadButton":
            return <UiDownloadButton key={viewModel.id} model={viewModel} />;
        case "uiEmailSignup":
            return <UiEmailSignup key={viewModel.id} model={viewModel} />;
        case "uiFeatureSection":
            return <UiFeatureSection key={viewModel.id} model={viewModel} />;
        case "uiFooterNav":
            return <UiFooterNav key={viewModel.id} model={viewModel} />;
        case "uiFooterNavBasic":
            return <UiFooterNavBasic key={viewModel.id} model={viewModel} />;
        case "uiGuide":
            return <UiGuide key={viewModel.id} model={viewModel} />;
        case "uiHeaderNav":
            return <UiHeaderNav key={viewModel.id} model={viewModel} />;
        case "uiHeading":
            return <UiHeading key={viewModel.id} model={viewModel} />;
        case "uiIcon":
            return <UiIcon key={viewModel.id} model={viewModel} />;
        case "uiImage":
            return <UiImage key={viewModel.id} model={viewModel} />;
        case "uiImageSet":
            return <UiImageSet key={viewModel.id} model={viewModel} />;
        case "uiIntegration":
            return <UiIntegration key={viewModel.id} model={viewModel} />;
        case "uiIntegrationSection":
            return (
                <UiIntegrationSection key={viewModel.id} model={viewModel} />
            );
        case "uiLoginContainer":
            return <UiLoginContainer key={viewModel.id} model={viewModel} />;
        case "uiLoginSignupForm":
            return <UiLoginSignupForm key={viewModel.id} model={viewModel} />;
        case "uiLink":
            return <UiLink key={viewModel.id} model={viewModel} />;
        case "uiLinkBlock":
            return <UiLinkBlock key={viewModel.id} model={viewModel} />;
        case "uiListCarousel":
            return <UiListCarousel key={viewModel.id} model={viewModel} />;
        case "uiMarkdown":
            return <UiMarkdown key={viewModel.id} model={viewModel} />;
        case "uiMarketoForm":
            return <UiMarketoForm key={viewModel.id} model={viewModel} />;
        case "uiModal":
            return <UiModal key={viewModel.id} model={viewModel} />;
        case "uiNavBanner":
            return <UiNavBanner key={viewModel.id} model={viewModel} />;
        case "uiNavBlogArticle":
            return <UiNavBlogArticle key={viewModel.id} model={viewModel} />;
        case "uiNavImages":
            return <UiNavImages key={viewModel.id} model={viewModel} />;
        case "uiNavLink":
            return <UiNavLink key={viewModel.id} model={viewModel} />;
        case "uiPowerUp":
            return <UiPowerUp key={viewModel.id} model={viewModel} />;
        case "uiPricingCalculator":
            return <UiPricingCalculator key={viewModel.id} model={viewModel} />;
        case "uiPricingComparisonTable":
            return (
                <UiPricingComparisonTable
                    key={viewModel.id}
                    model={viewModel}
                />
            );
        case "uiPricingGrid":
            return <UiPricingGrid key={viewModel.id} model={viewModel} />;
        case "uiQuote":
            return <UiQuote key={viewModel.id} model={viewModel} />;
        case "uiRecommendShare":
            return <UiRecommendShare key={viewModel.id} model={viewModel} />;
        case "uiRotatingImages":
            return <UiRotatingImages key={viewModel.id} model={viewModel} />;
        case "uiRotatingItems":
            return <UiRotatingItems key={viewModel.id} model={viewModel} />;
        case "uiSection":
            return <UiSection key={viewModel.id} model={viewModel} />;
        case "uiSectionGroup":
            return <UiSectionGroup key={viewModel.id} model={viewModel} />;
        case "uiSocialLoginSignupButton":
            return (
                <UiSocialLoginSignupButton
                    key={viewModel.id}
                    model={viewModel}
                />
            );
        case "uiSocialProof":
            return <UiSocialProof key={viewModel.id} model={viewModel} />;
        case "uiSocialShare":
            return <UiSocialShare key={viewModel.id} model={viewModel} />;
        case "uiSpacer":
            return <UiSpacer key={viewModel.id} model={viewModel} />;
        case "uiSplitSection":
            return <UiSplitSection key={viewModel.id} model={viewModel} />;
        case "uiStack":
            return <UiStack key={viewModel.id} model={viewModel} />;
        case "uiStatuspage":
            return <UiStatuspage key={viewModel.id} model={viewModel} />;
        case "uiStoryline":
            return <UiStoryline key={viewModel.id} model={viewModel} />;
        case "uiTab":
            return <UiTab key={viewModel.id} model={viewModel} />;
        case "uiTabPanel":
            return <UiTabPanel key={viewModel.id} model={viewModel} />;
        case "uiTemplateGallery":
            return <UiTemplateGallery key={viewModel.id} model={viewModel} />;
        case "uiTextBlock":
            return <UiTextBlock key={viewModel.id} model={viewModel} />;
        case "uiTrelloBoard":
            return <UiTrelloBoard key={viewModel.id} model={viewModel} />;
        case "uiTooltip":
            return <UiTooltip key={viewModel.id} model={viewModel} />;
        case "uiValueProp":
            return <UiValueProp key={viewModel.id} model={viewModel} />;
        case "uiVariationContainer":
            return (
                <UiVariationContainer key={viewModel.id} model={viewModel} />
            );
        case "uiVideo":
            return <UiVideo key={viewModel.id} model={viewModel} />;
        case "uiVideoPlayer":
            return <UiVideoPlayer key={viewModel.id} model={viewModel} />;
        case "uiWebinarLink":
            return <UiWebinarLink key={viewModel.id} model={viewModel} />;
        case "uiWorkspacePicker":
            return <UiWorkspacePicker key={viewModel.id} model={viewModel} />;
        default:
            return <ViewModelError key={`${Date.now()}`} model={viewModel} />;
    }
}

export function renderViewModels(
    viewModels: readonly ViewModel[]
): readonly ReactElement[] {
    return viewModels.map((viewModel, index) => {
        // Clone the element and add index to key to prevent duplicates
        const element = renderViewModel(viewModel);
        return {
            ...element,
            key: `${viewModel.id}-${index}`
        } as ReactElement;
    });
}
